import React from "react";
import Loader from "./../../assets/loader.gif";
import "./index.css";
function Loading(props) {
  return (
    <div className="loader-container">
      <img src={Loader} alt="loader"/>
    </div>
  );
}
export default Loading;
